import { useMsal } from "@azure/msal-react";
import { usePermissions } from "src/store/jotai";

type DeepValues<T> = T extends object
  ? { [K in keyof T]: DeepValues<T[K]> }[keyof T]
  : T;

export const PERMISSIONS = {
  USER_RIGHTS_CONTROL: {
    USERS: {
      ACCESS: "userRightsControl.users.access",
      INCLUDE: "userRightsControl.users.include",
      ALTER: "userRightsControl.users.alter",
      DELETE: "userRightsControl.users.delete",
      INACTIVATE: "userRightsControl.users.inactivate"
    },
    GROUPS: {
      ACCESS: "userRightsControl.groups.access",
      INCLUDE: "userRightsControl.groups.include",
      ALTER: "userRightsControl.groups.alter",
      DELETE: "userRightsControl.groups.delete"
    }
  }
} as const;

export type PermissaoType = DeepValues<typeof PERMISSIONS>;

export const useIdentity = () => {
  const { instance } = useMsal();

  const { value: currentUserClaims } = usePermissions();

  const validateUserAccess = (claimPath: PermissaoType) => {
    const activeAccount = instance.getActiveAccount();

    if (activeAccount?.idTokenClaims?.extension_Admin) return true;

    return currentUserClaims?.includes(claimPath);
  };

  return { validateUserAccess };
};
